"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Heading = require("./Heading");

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Heading2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-heading/lib/index.js
// module id = 329
// module chunks = 0